import { Checkbox, Input, InputNumber } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { FC, useEffect, useState } from 'react';
import { formatDate } from 'src/utils/date-util';

import classes from './NotificationDashboard.module.scss';

import DailyPricePushModal from './DailyPricePushModal/DailyPricePushModal';
import NotificationForm from './NotificationForm/NotificationForm';

const Notification: FC = () => {
  const [defaultTitle, setDefaultTitle] = useState<string>(
    `[이웃삼촌-${formatDate(new Date(), 'L월d일')} 야채가격 알려드립니다.]`,
  );
  const [isCustomTitle, setIsCustomTitle] = useState(false);
  const [customTitle, setCustomTitle] = useState('');
  const [dailyTalkMonth, setDailyTalkMonth] = useState(2);

  const onCustomTitleCheck = (e: CheckboxChangeEvent) => {
    setIsCustomTitle(e.target.checked);
  };

  const onCustomTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCustomTitle(e.target.value);
  };

  const onChangeDailyTalkMonth = (value: number | null) => {
    setDailyTalkMonth(value ?? 1);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setDefaultTitle(`[이웃삼촌-${formatDate(new Date(), 'L월d일')} 야채가격 알려드립니다.]`);
    }, 1000 * 60);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <>
      <div className={classes.notificationContaincer}>
        <h1>알림</h1>
        <p>사용자에게 알림을 보내거나 관련 설정을 변경할 수 있습니다.</p>

        <section>
          <h2>일일 가격 알림 (푸시)</h2>
          <p>
            설정한 기간의 주문과 즐겨찾기를 기반으로 일일 가격 알림 푸시를 전송합니다.
            <br />
            알림 수신에 동의한 앱 사용자에게 발송됩니다.
          </p>
          <div className={classes.dailyTalkContainer}>
            <div className={classes.dailyPriceContent}>
              <p style={{ marginBottom: 8 }}>관심 상품에 포함할 주문 기간</p>
              <InputNumber
                min={1}
                max={24}
                value={dailyTalkMonth}
                onChange={onChangeDailyTalkMonth}
                addonAfter='개월'
              />
              <br />
              <Checkbox
                onChange={onCustomTitleCheck}
                checked={isCustomTitle}
                style={{ marginBottom: 10, marginTop: 20 }}
              >
                제목 직접 입력
              </Checkbox>
              <Input disabled={!isCustomTitle} placeholder={defaultTitle} onChange={onCustomTitleChange} />
            </div>
            <div className={classes.right}>
              <div className={classes.pushPreview}>
                <div className={classes.pushHeader}>
                  <span className={classes.appName}>이웃삼촌</span>
                  <span className={classes.pushTime}>지금</span>
                </div>
                <p className={classes.pushTitle}>{isCustomTitle ? customTitle : defaultTitle}</p>
                <p className={classes.pushBody}>
                  깐마늘(1kg/대/국내산) 9,800원
                  <br />
                  깐생강(1kg/A급/국내산) 9,000원
                  <br />
                  ...
                </p>
              </div>
            </div>
          </div>
          <DailyPricePushModal title={isCustomTitle ? customTitle : defaultTitle} month={dailyTalkMonth} />
        </section>
        <div className={classes.divider} />
        <section>
          <h2>이웃삼촌 알림</h2>
          <p>이웃삼촌 서비스의 우측 상단에 표시되는 알림을 생성합니다.</p>
          <div>
            <NotificationForm />
          </div>
        </section>
      </div>
    </>
  );
};

export default Notification;
